module.exports = __webpack_public_path__ + "Montserrat-Light.88779338a024277ed283.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Montserrat-Light.ttf
// module id = 277
// module chunks = 2